// extracted by mini-css-extract-plugin
module.exports = {"container":"team_container__h1gu7","header":"team_header__nFnbx","title":"team_title__T0XZd","subtitle":"team_subtitle__UqANY","list":"team_list__2RGNY"};